import GeoJSON from 'ol/format/GeoJSON.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import { Fill, Stroke, Style } from 'ol/style.js';
import WebGLPointsLayer from 'ol/layer/WebGLPoints';
import { transformExtent } from 'ol/proj.js';


// Der Extent kann nicht verwendet werden, weil ein Bug existieren dürfte: https://github.com/openlayers/openlayers/issues/13788
function transform(extent) {
    return transformExtent(extent, 'EPSG:4326', 'EPSG:3857');
}

const extent = transform([10.41589, 53.88013, 11.31233, 54.53562]);


// Verschiedene zusätzliche Layer erzeugen & exportieren
//aoi_in
export const aoiIn = new VectorLayer({
    id: "aoi_in",
    visible: true,
    source: new VectorSource({
        url: './data/aoi_oh_inv.geojson',
        format: new GeoJSON(),
    }),
    style: new Style({
        fill: new Fill({
            color: "rgba(250, 250, 250, 0.85)",
            width: 5,
            lineCap: "round"
        })
    })
});

export const aoi = new VectorLayer({
    id: "aoi",
    visible: false,
    source: new VectorSource({
        url: './data/aoi_oh_k.geojson',
        format: new GeoJSON(),
    }),
    style: new Style({
        stroke: new Stroke({
            color: "rgba(0, 0, 0, 0.6)"
        })
    })
});

export const poi = new WebGLPointsLayer({
    extent: extent,
    id: "poi",
    visible: false,
    source: new VectorSource({
        url: './data/poi_osm.geojson',
        format: new GeoJSON(),
    }), style: {
        symbol: {
            symbolType: 'circle',
            "size": [
                "interpolate",
                [
                    "exponential",
                    3
                ],
                [
                    "zoom"
                ],
                2,
                1,
                28,
                256
            ],
            color: 'rgb(252, 152, 3)',
            opacity: 0.05,
        },
    },
});

export const oepnv = new WebGLPointsLayer({
    id: "oepnv",
    visible: false,
    extent: extent,
    source: new VectorSource({
        url: './data/oepnv_osm.geojson',
        format: new GeoJSON(),
    }), style: {
        symbol: {
            symbolType: 'circle',
            "size": [
                "interpolate",
                [
                    "exponential",
                    3
                ],
                [
                    "zoom"
                ],
                2,
                1,
                28,
                256
            ],
            color: 'rgb(95, 158, 160)',
            opacity: 0.1,
        },
    },
});



